import { MultiPolygon, multiPolygon, polygon } from "@turf/helpers";

import { ClickSelectionResolver } from "../../../types";
import { PickingInfo } from "deck.gl";
import { SelectionType } from "src/js/stores/map/store";
import { SitesGeoJsonLayer, SitesMvtLayer } from "../SitesGeoJsonLayer";
import { getDeckInstance } from "src/js/plugins/deck.gl/deckInstance";
import { getDeckLayerInstanceIds } from "react-migration/lib/map/getLayerInstances";
import { isSiteBoundary } from "../utils";
import { SiteFeature } from "src/js/stores/siteGeometry/store";
import { Feature, Polygon } from "@turf/turf";

type SiteMVTFeature = Feature<
  Polygon | MultiPolygon,
  {
    id: string;
  }
>;

function idAccessor(feature: SiteFeature | SiteMVTFeature): string {
  return feature?.properties?.id || feature?.id;
}

export const sitesClickResolver: ClickSelectionResolver = (pickInfo: PickingInfo<unknown>) => {
  const { x, y } = pickInfo;
  const deck = getDeckInstance();
  const layerIds = getDeckLayerInstanceIds([SitesGeoJsonLayer, SitesMvtLayer]);

  for (const pick of deck?.pickMultipleObjects({ x, y, layerIds }) || []) {
    const siteSelection = sitePickResolver(pick);

    if (siteSelection) return siteSelection;
  }

  return null;
};

export function sitePickResolver(pick: PickingInfo<unknown>) {
  if (!isSiteBoundary(pick.object)) return;

  const type = pick.object.properties.shared ? SelectionType.SHARED_SITE : SelectionType.SITE;

  const selectionProperties = {
    type,
    id: idAccessor(pick.object),
    addresses: [pick.object.properties.title],
    savable: false,
  };

  switch (pick.object.geometry?.type) {
    case "MultiPolygon":
      return {
        ...selectionProperties,
        feature: multiPolygon(pick.object.geometry?.coordinates, pick.object.properties),
      };

    case "Polygon":
      return {
        ...selectionProperties,
        feature: polygon(pick.object.geometry?.coordinates, pick.object.properties),
      };
  }
}
